import {
  SET_CASES,
  SET_CLIENT,
  SET_CURRENT_CASE,
  SET_LAST_ACCESSED_CASES,
  SET_PAGES,
  SET_ALL_CLIENTS,
  SET_TODOS,
  SET_TODO_TABS,
  SET_SEARCH_TABLE_LOADER,
  SET_ERROR,
  SET_LOADING,
  SET_CURRENT_TODOS_TAB,
  SET_WORK_LIST_DATA,
  SOCKET_TODO_UPSERT,
  SOCKET_TODO_DELETE,
  // SOCKET_TODO_WORKLIST_UPSERT,
} from "./actions";

const initialState = {
  searchResults: [],
  currentSearchStatus: "clients",
  currentTab: "All Open",

  searchName: "A",
  searchText: "",
  searchTableLoader: false,
  loginLoader: false,
  tabsResultCount: {
    "client-name": 0,
    "client-email": 0,
    defendant: 0,
    witness: 0,
    claim: 0,
    "court-case": 0,
    otherparty: 0,
    address: 0,
    notes: 0,
    document: 0,
  },
  loading: false,
  error: null,
  cases: [],
  client: null,
  currentCase: null,
  lastAccessedCases: [],
  pages: [],
  allClients: [],
  todos: [],
  todoTabs: [],
  injuriesData: [],
  todosTab: 0,
  workListData: [],
};

// ───────── socket upsert/delete helpers ─────────

// CONFIRM THIS. Must return the value on a tab that equals todo.todo_type.id.
// tab.id is the FIRST guess only — if that's a tab PK (not a todo_type PK),
// socket todos route to the wrong tab. Replace with the real field.
function tabTodoTypeId(tab) {
  return tab?.todo_type_id ?? tab?.todo_type?.id ?? tab?.type_id ?? tab?.id;
}

// destination bucket (all_open / completed): replace in place if present, prepend if new, drop if it no longer belongs
function placeInBucket(list = [], todo, belongs) {
  const i = list.findIndex((t) => t.id === todo.id);
  if (belongs) {
    if (i === -1) return [todo, ...list];
    const copy = list.slice();
    copy[i] = todo;
    return copy;
  }
  if (i === -1) return list;
  return list.filter((t) => t.id !== todo.id);
}

// per-type tab always holds the todo (view filters complete): replace in place, else prepend
function upsertInPlace(list = [], todo) {
  const i = list.findIndex((t) => t.id === todo.id);
  if (i === -1) return [todo, ...list];
  const copy = list.slice();
  copy[i] = todo;
  return copy;
}

function removeById(list = [], id) {
  return list.filter((t) => t.id !== id);
}

const todosReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CASES:
      return { ...state, cases: action.payload };
    case SET_CLIENT:
      return { ...state, client: action.payload };
    case SET_CURRENT_CASE:
      return { ...state, currentCase: action.payload };
    case SET_LAST_ACCESSED_CASES:
      return { ...state, lastAccessedCases: action.payload };
    case SET_PAGES:
      return { ...state, pages: action.payload };
    case SET_ALL_CLIENTS:
      return { ...state, allClients: action.payload };
    case SET_TODOS:
      return { ...state, todos: action.payload };
    case SET_TODO_TABS:
      return { ...state, todoTabs: action.payload };
    case SET_CURRENT_TODOS_TAB:
      return { ...state, todosTab: action.payload };
    case SET_SEARCH_TABLE_LOADER:
      return { ...state, searchTableLoader: action.payload };
    case SET_WORK_LIST_DATA:
      return { ...state, workListData: action.payload };
    case SET_LOADING:
      return { ...state, loading: action.payload };
    case SET_ERROR:
      return { ...state, error: action.payload };

    case SOCKET_TODO_UPSERT: {
      const todo = action.payload;
      if (!todo?.id) return state;
      // eslint-disable-next-line no-console
      console.log(action);
      // eslint-disable-next-line no-console
      console.log(action.payload);
      // state.todos is the API response object (todos_all_open / todos_completed live here)
      const resp = state.todos && !Array.isArray(state.todos) ? state.todos : {};
      const typeId = todo?.todo_type?.id;

      return {
        ...state,
        todos: {
          ...resp,
          todos_all_open: placeInBucket(resp.todos_all_open, todo, !todo.complete),
          todos_completed: placeInBucket(resp.todos_completed, todo, !!todo.complete),
        },
        todoTabs: (state.todoTabs || []).map((tab) =>
          String(tabTodoTypeId(tab)) === String(typeId)
            ? { ...tab, todo_data: upsertInPlace(tab.todo_data, todo) }
            : tab
        ),
      };
    }

    case SOCKET_TODO_DELETE: {
      const id = action.payload;
      if (id === null) return state;

      const resp = state.todos && !Array.isArray(state.todos) ? state.todos : {};

      return {
        ...state,
        todos: {
          ...resp,
          todos_all_open: removeById(resp.todos_all_open, id),
          todos_completed: removeById(resp.todos_completed, id),
        },
        todoTabs: (state.todoTabs || []).map((tab) => ({
          ...tab,
          todo_data: removeById(tab.todo_data, id),
        })),
      };
    }

    default:
      return state;
  }
};

export default todosReducer;
